// Convention for constants: [License]_[Action]
// Replaced keymirror with plain object — keys equal their string values.
const LicenseConstants = {
    LICENSE_GET_ALL: 'LICENSE_GET_ALL',
    LICENSE_GET_INFO: 'LICENSE_GET_INFO',
    LICENSE_BEGIN_ADD: 'LICENSE_BEGIN_ADD',
    LICENSE_ADD_UPDATE: 'LICENSE_ADD_UPDATE',
    LICENSE_ADD: 'LICENSE_ADD',
    LICENSE_FINISH_ADD: 'LICENSE_FINISH_ADD',
} as const;

export default LicenseConstants;
